import { FilterOptionsByType } from "../shared/components/SearchFilterBar/FilterOptions";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertFilterOptionsToParam = (
    stackFilterOptions: FilterOptionsByType
) => {
    const queryParams: { [key: string]: string } = {};

    Object.keys(stackFilterOptions).forEach((key: string) => {
        const stackFilterOption = stackFilterOptions[key];

        const dataAsArray = stackFilterOption.data as any[];
        const dataAsString = stackFilterOption.data as string;

        if (stackFilterOption.type === "date") {
            if (dataAsString) queryParams[key] = dataAsString;
        } 
        // date_range_utc: has been converted to UTC timezone in the frontend. Example: 2026-04-11T00:00:00.000Z
        else if (stackFilterOption.type === "date_range_utc") {
            const [firstDate, lastDate] = dataAsArray;
            const firstDateObj = typeof firstDate === 'string' ? { query: firstDate } : firstDate;
            const lastDateObj  = typeof lastDate  === 'string' ? { query: lastDate  } : lastDate;
            if (firstDateObj?.query) {
                queryParams[`${key}__gte`] = dayjs.tz(firstDateObj.query, 'Asia/Ho_Chi_Minh').startOf('day').utc().toISOString();
            }
            if (lastDateObj?.query) {
                queryParams[`${key}__lte`] = dayjs.tz(lastDateObj.query, 'Asia/Ho_Chi_Minh').endOf('day').utc().toISOString();
            }
        } 
        // date_range: Only date, no time. Example: 2026-04-11
        else if (stackFilterOption.type === "date_range") {
            const [firstDate, lastDate] = dataAsArray;
            const firstDateObj = typeof firstDate === 'string' ? { query: firstDate } : firstDate;
            const lastDateObj  = typeof lastDate  === 'string' ? { query: lastDate  } : lastDate;
            if (firstDateObj?.query) {
                queryParams[`${key}__gte`] = dayjs(firstDateObj.query).format("YYYY-MM-DD");
            }
            if (lastDateObj?.query) {
                queryParams[`${key}__lte`] = dayjs(lastDateObj.query).format("YYYY-MM-DD");
            }
        }
        else if (stackFilterOption.type === "price_range") {
            const [firstPrice, lastPrice] = dataAsArray;
            queryParams[`${key}__gte`] = firstPrice.query;
            queryParams[`${key}__lte`] = lastPrice.query;
        } else if (stackFilterOption.type === "category_group") {
            queryParams[key] = dataAsArray.map((item: any) => item).join(",");
        } else {
            queryParams[key] = dataAsArray.map((item: any) => item.query).join(",");
        }
    });

    return queryParams;
};
